import styled from "styled-components";

import { DESKTOP_BREAKPOINT } from "../../../../components/AppShell/styles";
import { buttonLoadingCss } from "../../../../components/Button";

const MOBILE = `not all and (min-width: ${DESKTOP_BREAKPOINT})`;

/* The manage screens follow the subscription screen: same width, titled sections */
/* The checkout's narrow column (520px of content), centered */
export const Container = styled.div`
  /* Always the column's full width (not sized by what's open inside it) */
  width: 100%;
  max-width: calc(520px + 4rem);
  margin: 0 auto;
  padding-bottom: 2rem;

  /* The global reset gives every element the system font: these screens are Inter */
  &,
  & * {
    font-family: Inter, sans-serif;
  }
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1.5rem 2rem 0;

  @media ${MOBILE} {
    padding: 20px 20px 0;
  }
`;

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.25rem;
  background: var(--color-neutral-dark);
  border-radius: 1rem;

  .intro {
    font-size: 0.8125rem;
    line-height: 1.25rem;
    color: var(--color-neutral-150);
  }

  @media ${MOBILE} {
    padding: 1rem;
  }
`;

/* What's in use today: icon, name and detail, on one row */
export const Current = styled.div`
  display: flex;
  gap: 0.875rem;
  align-items: center;
  padding: 1rem 1.25rem;
  background: var(--color-neutral-dark);
  border-radius: 1rem;

  .icon {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    color: var(--color-neutral-white);
    background: rgba(255, 255, 255, 0.06);
    border-radius: 10px;
  }

  .text {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.125rem;
    min-width: 0;

    b {
      font-size: 0.9375rem;
      font-weight: 700;
      color: var(--color-neutral-white);
    }

    span {
      font-size: 0.75rem;
      color: var(--color-neutral-150);
    }
  }

  .badge {
    flex-shrink: 0;
    padding: 0.125rem 0.5rem;
    font-size: 0.625rem;
    font-weight: 800;
    color: var(--color-brand-plus);
    text-transform: uppercase;
    background: rgba(87, 242, 139, 0.15);
    border-radius: 100px;
  }
`;

/* The change being made, line by line, before confirming it */
export const ChangeSummary = styled.dl`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  padding: 1.25rem;
  font-size: 0.875rem;
  background: var(--color-neutral-dark);
  border-radius: 1rem;

  div {
    display: flex;
    gap: 1rem;
    justify-content: space-between;
  }

  dt {
    color: var(--color-neutral-150);
  }

  dd {
    font-weight: 700;
    color: var(--color-neutral-white);
    text-align: right;
  }

  .credit dd {
    color: var(--color-brand-plus);
  }

  .total {
    padding-top: 0.75rem;
    margin-top: 0.125rem;
    border-top: 1px solid var(--color-neutral-base);

    dt,
    dd {
      font-size: 1rem;
      font-weight: 800;
      color: var(--color-neutral-white);
    }
  }

  .note {
    display: block;
    font-size: 0.75rem;
    line-height: 1.125rem;
    color: var(--color-neutral-150);
  }
`;

/* Save / confirm, and the way out */
export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1.5rem 2rem 0;

  .primary {
    display: inline-flex;
    gap: 0.5rem;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 1rem;
    font-size: 0.9375rem;
    font-weight: 800;
    color: var(--color-neutral-white);
    background: var(--color-brand-blue);
    border-radius: 100px;
    transition: filter 0.15s;

    &:hover:not(:disabled) {
      filter: brightness(1.12);
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }

    /* Saving: Keepo's loading (the Button's), the label hidden */
    &[aria-busy="true"] {
      ${buttonLoadingCss}

      &:disabled {
        opacity: 1;
      }
    }
  }

  .secondary {
    padding: 0.5rem;
    font-size: 0.8125rem;
    font-weight: 700;
    color: var(--color-neutral-150);
    transition: color 0.15s;

    &:hover {
      color: var(--color-neutral-white);
    }
  }

  .error {
    font-size: 0.875rem;
    color: var(--color-feedback-danger);
    text-align: center;
  }

  .done {
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
    font-weight: 700;
    color: var(--color-brand-plus);
    text-align: center;
    background: rgba(87, 242, 139, 0.1);
    border-radius: 12px;
  }

  @media ${MOBILE} {
    padding: 20px 20px 0;
  }
`;
